import React, { FC } from 'react'
import { Dashboard } from '../../common/components/Dashboard'

export const AssistantDashboard: FC<React.PropsWithChildren<unknown>> = () => {
  return <Dashboard />
}
